import React from "react";
import { ThemeProvider } from "styled-components";
import { theme } from "./src/ui/themes";

// eslint-disable-next-line react/prop-types
export const wrapRootElement = ({ element }) => (
  <ThemeProvider theme={theme}>{element}</ThemeProvider>
);
